import Vue from 'vue'
import { io } from 'socket.io-client'

let userId = null
const userHoFacil = localStorage.getItem('userHoFacil')
if (userHoFacil) {
  try {
    const parsed = JSON.parse(userHoFacil)

    if (parsed && parsed.id) {
      userId = parsed.id
    }
  } catch (error) {
    console.error('userHoFacil inválido no localStorage:', userHoFacil)
  }
}
const socket = io(process.env.VUE_APP_BASE_URL_WEBSOCKET, {
  transports: ['websocket'],
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  auth: {
    userId
  }
})

Vue.prototype.$socket = socket

export default socket
